package api.data

import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.Timestamp
import dev.gitlive.firebase.firestore.externals.collection
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DataProperty(
    @SerialName("id")
    var id: String? = null,

    @SerialName("title")
    var title: String? = null,

    @SerialName("location")
    var location: String? = null,

    @SerialName("size")
    var size: Double? = null,

    @SerialName("bedrooms")
    var bedrooms: Int? = 0,

    @SerialName("bathrooms")
    var bathrooms: Int? = 0,

    @SerialName("description")
    var description: String? = null,

    @SerialName("type")
    var type: String? = null,

    @SerialName("price")
    var price: Int? = 0,

    @SerialName("currency")
    var currency: String? = null,

    @SerialName("amenities")
    var amenities: ArrayList<String>? = null,

    @SerialName("features")
    var features: List<String>? = null,

    @SerialName("yearBuilt")
    var yearBuilt: Int? = null,

    @SerialName("images")
    var images: ArrayList<String>? = null,

    @SerialName("ownerEmail")
    var ownerEmail: String? = null,

    @SerialName("ownerFirstName")
    var ownerFirstName: String? = null,

    @SerialName("ownerLastName")
    var ownerLastName: String? = null,

    @SerialName("ownerPhone")
    var ownerPhone: String? = null,

    @SerialName("purpose")
    var purpose: String? = null,

    @SerialName("status")
    var status: String? = null,

    @SerialName("isApproved")
    var isApproved: Boolean? = false,

    @SerialName("rejectedBy")
    var rejectedBy: String? = null,

    @SerialName("rejectionReason")
    var rejectionReason: String? = null,

    @SerialName("approvedBy")
    var approvedBy: String? = null,

    @SerialName("approvedOn")
    var approvedOn: Timestamp? = null,

    @SerialName("createdOn")
    var createdOn: Timestamp? = null,

    @SerialName("updatedOn")
    var updatedOn: Timestamp? = null,

    @SerialName("submittedBy")
    var submittedBy: String? = null,

    @SerialName("rentBillFrequency")
    var rentBillFrequency: String? = null
//    @SerialName("inquiries")
//    var inquiries: DataPropertyInquiry? = null
    )




fun DocumentSnapshot.toDataProperty(): DataProperty {
    return DataProperty(
        id = get("id"),
        title = get("title"),
        location = get("location"),
        size = get("size"),
        bedrooms = get("bedrooms"),
        bathrooms = get("bathrooms"),
        description = get("description"),
        type = get("type"),
        price = get("price"),
        currency = get("currency"),
        amenities = get("amenities"),
        features = get("features"),
        yearBuilt = get("yearBuilt"),
        images = get("images"),
        ownerEmail = get("ownerEmail"),
        ownerPhone = get("ownerPhone"),
        ownerFirstName = get("ownerFirstName"),
        ownerLastName = get("ownerLastName"),
        purpose = get("purpose"),
        status = get("status"),
        isApproved = get("isApproved"),
        rejectedBy = get("rejectedBy"),
        rejectionReason = get("rejectionReason"),
        approvedBy = get("approvedBy"),
        approvedOn = get("approvedOn"),
        createdOn = get("createdOn"),
        updatedOn = get("updatedOn"),
        rentBillFrequency = get("rentBillFrequency")
    )
}